import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["isPrimaryDomain", "onRemoveDomain", "onPromoteDomain"];
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import unescapedText from 'I18n/utils/unescapedText';
import UIButton from 'UIComponents/button/UIButton';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UIGrid from 'UIComponents/grid/UIGrid';
import UIGridItem from 'UIComponents/grid/UIGridItem';
import UIList from 'UIComponents/list/UIList';
import UITag from 'UIComponents/tag/UITag';
import DomainInput from './DomainInput';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ExistingValue(props) {
  const {
    value,
    onRemoveDomain,
    onPromoteDomain,
    isPrimaryDomain
  } = props;
  const rest = _objectWithoutPropertiesLoose(props, _excluded);
  const classes = 'p-left-0' + (isPrimaryDomain ? " p-top-2" : "");
  return /*#__PURE__*/_jsxs(UIGrid, {
    children: [/*#__PURE__*/_jsx(UIGridItem, {
      size: {
        xs: 8
      },
      children: /*#__PURE__*/_jsx(DomainInput, Object.assign({
        className: "p-x-2"
      }, rest))
    }), /*#__PURE__*/_jsx(UIGridItem, {
      size: {
        xs: 4
      },
      className: classes,
      children: isPrimaryDomain ? /*#__PURE__*/_jsx(UITag, {
        className: "m-left-5",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "customerDataProperties.PropertyInputMultipleDomain.primaryDomainTag"
        })
      }) : /*#__PURE__*/_jsx(UIDropdown, {
        buttonUse: "transparent",
        buttonText: unescapedText('customerDataProperties.PropertyInputMultipleDomain.actions'),
        children: /*#__PURE__*/_jsxs(UIList, {
          children: [/*#__PURE__*/_jsx(UIButton, {
            use: "transparent",
            size: "extra-small",
            onClick: () => {
              onPromoteDomain(value);
            },
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "customerDataProperties.PropertyInputMultipleDomain.makePrimary"
            })
          }), /*#__PURE__*/_jsx(UIButton, {
            use: "transparent",
            size: "extra-small",
            onClick: () => {
              onRemoveDomain(value);
            },
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "customerDataProperties.PropertyInputMultipleDomain.delete"
            })
          })]
        })
      })
    })]
  });
}
export default ExistingValue;